import React from 'react';
import { motion } from 'framer-motion';
import { useSiteContent } from '../../context/SiteContentContext';
import LanguageAwareVideo from '../common/LanguageAwareVideo';
import { buildSubtitleTracks } from '../../utils/subtitles';

const IntroVideo = () => {
  const { siteContent } = useSiteContent();
  const introVideo = siteContent?.introVideo || {};

  if (introVideo.visible === false) return null;

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-12"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-slate-900 mb-4">
            {introVideo.title || 'Why Parents and Students Choose English Passion'}
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-3xl mx-auto">
            {introVideo.subtitle || 'Watch a short introduction to our teaching philosophy and how we help learners of all ages grow with confidence.'}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="relative rounded-2xl overflow-hidden shadow-2xl shadow-slate-900/10 bg-slate-900"
        >
          <LanguageAwareVideo
            videoUrl={introVideo.videoUrl || "/videos/intro.mp4"}
            subtitles={buildSubtitleTracks(introVideo.subtitles)}
            testId="intro-video"
            containerClassName="bg-slate-900"
          />
          
          <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-amber-100/30 rounded-full blur-3xl -z-10" />
          <div className="absolute -top-10 -right-10 w-48 h-48 bg-slate-200/30 rounded-full blur-3xl -z-10" />
        </motion.div>
      </div>
    </section>
  );
};

export default IntroVideo;
